import type { ValidatorField } from '../api/client'

export const GROUP_LABELS: Record<string, string> = {
  header:      'Documentinformatie',
  leverancier: 'Leverancier',
  koper:       'Koper',
  regels:      'Artikelregels',
  totalen:     'Totalen',
}

export const GROUP_ORDER = ['header', 'leverancier', 'koper', 'regels', 'totalen']

export function groupFields(fields: ValidatorField[]): Map<string, ValidatorField[]> {
  const map = new Map<string, ValidatorField[]>()
  for (const group of GROUP_ORDER) {
    const items = fields.filter(f => f.group === group)
    if (items.length > 0) map.set(group, items)
  }
  return map
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
